import React from "react";

const contacto = () => {
  return <h1>Página de contacto</h1>;
};

export default contacto;
